<template>
  <div>  
        <norilskSelect/>
        <norilskMap/> 
  </div>
</template>

<script>
import norilskSelect from './components/norilskSelect.vue'
import norilskMap from './components/norilskMap.vue'

export default {
  name: 'App',
  components: {
    norilskSelect,
    norilskMap
  },    
}
</script>
<style>
</style>
